import { render } from "./RestEvent.vue?vue&type=template&id=f2cc1722&scoped=true"
import script from "./RestEvent.vue?vue&type=script&lang=js"
export * from "./RestEvent.vue?vue&type=script&lang=js"

import "./RestEvent.vue?vue&type=style&index=0&id=f2cc1722&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2cc1722"]])

export default __exports__